import { aplicarColorDeTema } from '../../lib/preferencias';

const CLAVE = 'cqinv-theme';

export type TemaPublico = {
  readonly appName: string;
  readonly commercialName: string;
  readonly colors: Record<string, string>;
  readonly cssVars: Record<string, string>;
  readonly showPoweredBy: boolean;
  readonly loginTitle: string | null;
  readonly loginSubtitle: string | null;
  readonly loginFooter: string | null;
};

export function aplicarVariables(vars: Record<string, string>): void {
  const raiz = document.documentElement;
  for (const [k, v] of Object.entries(vars)) {
    raiz.style.setProperty(k, v);
  }
}

export function leerTemaLocal(): TemaPublico | null {
  try {
    const t = localStorage.getItem(CLAVE);
    return t ? (JSON.parse(t) as TemaPublico) : null;
  } catch {
    return null;
  }
}

export function guardarTemaLocal(tema: TemaPublico): void {
  localStorage.setItem(CLAVE, JSON.stringify(tema));
}

export async function cargarTemaRemoto(): Promise<TemaPublico | null> {
  const r = await fetch('/api/v1/branding/theme', { credentials: 'include' });
  if (!r.ok) return null;
  const tema = (await r.json()) as TemaPublico;
  guardarTemaLocal(tema);
  aplicarVariables(tema.cssVars);
  aplicarColorDeTema(tema.cssVars['--brand-primary']);
  return tema;
}
